import React, { useState } from "react";
import { showToast } from "../components/toast";
import axios from "axios";
import { API_URL } from "../config";
import LoadingSpinner from "../components/LoadingSpinner.jsx";

const AddFreeServicePopup = ({
  onClose,
  dropdownOptions,
  fetchSubscriptions,
}) => {
  const token = localStorage.getItem("authToken");
  const [freeServiceData, setFreeServiceData] = useState({
    fullname: "",
    mobileno: "",
    email: "",
    languageid: "",
    serviceid: "",
    stype: "Free",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleFreeServiceInputChange = (e) => {
    const { name, value } = e.target;
    setFreeServiceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const handleFreeServiceInputChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "mobileno") {
  //     // Allow only digits
  //     const onlyDigits = value.replace(/\D/g, "");

  //     // Limit to 10 digits (adjust if needed)
  //     if (onlyDigits.length > 10) return showToast.error("Mobile number should be 10 digits");

  //     setFreeServiceData((prevData) => ({
  //       ...prevData,
  //       [name]: onlyDigits,
  //     }));
  //   } else {
  //     setFreeServiceData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   }
  // };

  // Handle form submission
  const handleAddfreeService = async (e) => {
    e.preventDefault();
    if (!freeServiceData.mobileno || freeServiceData.mobileno.length !== 10) {
      showToast.error("Please enter a valid 10-digit mobile number");
      return; // Stop form submission
    }

    setIsLoading(true); // Show loading spinner

    try {
      const response = await axios.post(
        `${API_URL}subscription/save-free-service`,
        freeServiceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      //  Acttual API URL should be used here 221
      if (response.data.success === true) {
        showToast.success(
          response.data.message || "Service added successfully"
        );
        setTimeout(() => onClose(), 2000); // Close the modal after 2 seconds
        fetchSubscriptions();
      } else {
        showToast.error(response.data.message || "Failed to add Service");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // if (isLoading) {
  //   return <LoadingSpinner />;
  // }

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-md-11">
                <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                  Add Free Service
                </h5>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                &times;
              </button>
              <div className="clearfix"></div>
            </div>
            <div className="modal-body">
              <form
                onSubmit={handleAddfreeService}
                id="addFreeServiceForm"
                className="form-horizontal"
                encType="multipart/form-data"
              >
                <input type="hidden" name="from" value="popup" />
                <div className="panel-body">
                  <div className="row">
                    {/* Full Name */}
                    <div className="col-md-12 mb-2">
                      <label>
                        Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="fullname"
                        value={freeServiceData.fullname}
                        onChange={handleFreeServiceInputChange}
                        className="form-control"
                        placeholder="Enter Name"
                        required
                      />
                    </div>

                    {/* Mobile Number */}
                    <div className="col-md-12 mb-2">
                      <label>Mobile No. <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        name="mobileno"
                        value={freeServiceData.mobileno}
                        onChange={handleFreeServiceInputChange}
                        className="form-control"
                        placeholder="Enter Mobile No."
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="col-md-12 mb-2">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={freeServiceData.email}
                        onChange={handleFreeServiceInputChange}
                        className="form-control"
                        placeholder="Enter Email"
                      />
                    </div>

                    {/* Lead Source */}
                    <div className="col-md-12 mb-2">
                      <label>Languages <span style={{ color: "red" }}>*</span></label>
                      <select
                        name="languageid"
                        value={freeServiceData.languageid}
                        onChange={handleFreeServiceInputChange}
                        className="form-control"
                        required
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.languageList &&
                          dropdownOptions.languageList.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    {/* Language */}
                    <div className="col-md-12 mb-2">
                      <label>Service</label>
                      <select
                        name="serviceid"
                        value={freeServiceData.serviceid}
                        onChange={handleFreeServiceInputChange}
                        className="form-control"
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.serviceList &&
                          dropdownOptions.serviceList.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.service_name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div
                      className="col-md-12 mt-2"
                      style={{ textAlign: "right" }}
                    >
                      <button
                        type="submit"
                        className="btn btn-primary mx-2"
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddFreeServicePopup;
